/**
 * Maps a calendarAction's `actionType` to the header undo button's hover
 * tooltip, Excel-style ("Undo Clear", "Undo Move"). Verbs are kept consistent
 * with the full sentences the history sidebar shows for the same type
 * (ACTION_DESCRIPTION_BUILDERS in HistorySideBarContent.js). Keys mirror
 * node-server's CALENDAR_ACTION_NAME enum.
 */
const UNDO_ACTION_LABELS = {
  'assignment-add': 'Add',
  'assignment-update': 'Update',
  'assignment-delete': 'Delete',
  swap: 'Swap',
  reorder: 'Reorder',
  'update-future-occurrences': 'Update',
  'move-date': 'Move',
  clear: 'Clear',
  load: 'Load',
  'make-recurring': 'Make Recurring',
  'update-recurring': 'Update Recurring',
  'delete-recurring': 'Delete Recurring',
  'individual-assignments': 'Copy',
  'copy-single': 'Copy',
  'copy-multiple': 'Copy',
  'copy-range': 'Copy',
  save: 'Save',
};

/**
 * @param {string} [actionType] - the calendarAction.actionType, or undefined
 *   for legacy endpoints that only send `{ id }` with no actionType.
 * @returns {string} the tooltip text - "Undo <Type>" for a known actionType,
 *   or a plain "Undo" when the type is missing or unrecognized.
 */
const getUndoActionLabel = (actionType) => {
  const label = UNDO_ACTION_LABELS[actionType];
  return label ? `Undo ${label}` : 'Undo';
};

export default getUndoActionLabel;
